<script>
import MainContainer from '@/components/main/MainContainer.vue'
import UiHead from '@/components/UI/atoms/UiHead.vue'

export default {
	name: 'MainFunction',
	components: {
		MainContainer,
		UiHead,
	},
	data() {
		return {
			left: [
				{
					title: 'main_functions.1.title',
					text: 'main_functions.1.text',
					classes: `max-w-full lg:max-w-[397px]`,
				},
				{
					title: 'main_functions.2.title',
					text: 'main_functions.2.text',
					classes: `max-w-full lg:max-w-[322px]`,
				},
				{
					title: 'main_functions.3.title',
					text: 'main_functions.3.text',
					classes: `max-w-full lg:max-w-[382px]`,
				},
			],
			right: [
				{
					title: 'main_functions.4.title',
					text: 'main_functions.4.text',
					classes: `max-w-full lg:max-w-[313px]`,
				},
				{
					title: 'main_functions.5.title',
					text: 'main_functions.5.text',
					classes: `max-w-full lg:max-w-[313px]`,
				},
				{
					title: 'main_functions.6.title',
					text: 'main_functions.6.text',
					classes: `max-w-full lg:max-w-[357px]`,
				},
			],
		}
	},
}
</script>

<template>
	<section id="about" class="pt-[10px] pb-[40px] md:pt-[15px] md:pb-[84px] lg:pt-[25.19px] lg:pb-[84px]">
		<MainContainer class="relative">
			<div class="mb-[40px] md:mb-[60px] lg:mb-[95px]">
				<UiHead>
					{{ $t('titles.main_functions') }}
				</UiHead>
			</div>

			<div class="group relative flex flex-col justify-between items-stretch lg:flex-row">
				<div class="relative z-[2] flex flex-col items-start gap-[30px] text-left lg:gap-[46px]">
					<div
						v-for="item in left"
						:key="item.title"
						:class="item.classes"
						class="lg:min-h-[104px]"
					>
						<UiHead :tag="'h5'" class="mb-[5px]">
							<span v-html="$t(item.title)"></span>
						</UiHead>
						<div class="font-main font-light text-[14px] text-second">
							{{ $t(item.text) }}
						</div>
					</div>
				</div>
				<div
					class="relative w-[80.37%] min-h-[440px] mx-auto transform z-0 lg:absolute lg:top-1/2 lg:left-1/2 lg:-translate-x-1/2 lg:-translate-y-1/2 flex items-center justify-center"
				>
					<div
						:style="{ aspectRatio: 1, background: 'linear-gradient(to bottom,#FFFFFF,#E5F6FF)' }"
						class="w-[73.58%] min-w-[663px] rounded-full transform scale-0 duration-700 group-hover:scale-100"
					></div>
					<div
						:style="{ aspectRatio: 1 }"
						class="absolute top-1/2 left-1/2 w-[39.6%] min-w-[357px] transform -translate-x-1/2 -translate-y-1/2 rounded-full duration-700 bg-gradient-to-b from-[#ffffff] to-[#157FEE] opacity-100 scale-100 group-hover:opacity-0 group-hover:scale-90"
					></div>
					<div
						:style="{ aspectRatio: 1 }"
						class="absolute top-1/2 left-1/2 w-[39.6%] min-w-[357px] transform -translate-x-1/2 -translate-y-1/2 rounded-full duration-700 bg-gradient-to-b from-[#157FEE] to-[#ffffff] opacity-0 scale-100 group-hover:opacity-100 group-hover:scale-90"
					></div>
					<img
						src="@/assets/img/main/arrows.svg"
						alt=""
						class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 min-w-[452px]"
					/>
					<img
						src="@/assets/img/main/main_functions.svg"
						alt=""
						class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 min-h-[663px] min-w-[860px]"
					/>
				</div>
				<div
					class="relative z-[2] flex flex-col items-start gap-[30px] text-left lg:items-end lg:!text-right lg:gap-[46px]"
				>
					<div
						v-for="item in right"
						:key="item.title"
						:class="item.classes"
						class="lg:min-h-[104px]"
					>
						<UiHead :tag="'h5'" class="mb-[5px]">
							<span v-html="$t(item.title)"></span>
						</UiHead>
						<div class="font-main font-light text-[14px] text-second">
							{{ $t(item.text) }}
						</div>
					</div>
				</div>
			</div>
		</MainContainer>
	</section>
</template>

<style>
.main-logo span strong {
	font-weight: 800 !important;
	font-size: 12px;
	line-height: 0.9;
	text-transform: uppercase;
}
</style>
